"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const schedule_1 = __importDefault(require("../schedules/schedule"));
const call_1 = __importDefault(require("../call/call"));
const campaign_1 = __importDefault(require("../campaign/campaign"));
const typesConstants_1 = require("../../constants/typesConstants");
const support_1 = __importDefault(require("../support/support"));
const HomeComponent = () => {
    const { officer } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
    }));
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (officer.officer_type === typesConstants_1.OFFICER_TYPES_CUSTOMER_SUPPORT) {
        content = react_1.default.createElement(support_1.default, null);
    }
    else if (officer.scheduling_type === typesConstants_1.SCHEDULING_TYPE_AUTOMATED) {
        content = react_1.default.createElement(campaign_1.default, null);
    }
    else if (officer.schedule_mode) {
        content = react_1.default.createElement(schedule_1.default, null);
    }
    else {
        content = react_1.default.createElement(call_1.default, null);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, content);
};
exports.default = HomeComponent;
